import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ProfileFacade } from '@app/store/profile';
import { filter, map, tap } from 'rxjs';

// Don't render the authenticated shell (its header shows the user's name) until the profile
// is loaded, so the name is never blank/stale on entry. Mirrors loggedIn() / workstationSelected().
export const profileLoaded = (): CanActivateFn => {
    return () => {
        const profileFacade = inject(ProfileFacade);

        return profileFacade.loaded$.pipe(
            tap((loaded) => {
                if (loaded === null) {
                    profileFacade.getProfile();
                }
            }),
            filter((loaded) => loaded !== null),
            map(() => true),
        );
    };
};
